import React from "react";
import { Switch as SwitchRoot, SwitchProps } from "antd";

export const Switch = ({ checked, ...props }: SwitchProps) => {
  return (
    <div className="flex items-center gap-4">
      <SwitchRoot checked={checked} {...props} />
      <span className="text-[#A2A2A2]">{checked ? "On" : "Off"}</span>
    </div>
  );
};
